export const trackEvent = (eventName, payload = {}) => {
  try {
    if (typeof window !== 'undefined') {
      if (window.analytics?.track) {
        window.analytics.track(eventName, payload);
        return;
      }

      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
        return;
      }
    }

    if (process.env.NODE_ENV !== 'production') {
      // Fallback to console logging so we can still monitor behavior in development.
      console.debug(`[analytics] ${eventName}`, payload); // eslint-disable-line no-console
    }
  } catch (error) {
    if (process.env.NODE_ENV !== 'production') {
      console.debug('[analytics] failed to record event', eventName, error); // eslint-disable-line no-console
    }
  }
};
